import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-tool-link',
  templateUrl: './tool-link.component.html',
  styleUrls: ['./tool-link.component.scss'],
  imports: [MatTooltipModule, MatIconModule],
})
export class ToolLinkComponent {
  @Input() tooltip = '';
  @Input() externalLink = '';
  @Input() toolLabel = '';
  @Output() defaultClick = new EventEmitter();
  @Output() secondaryClick = new EventEmitter();
}
